import { css } from '@emotion/css'
import { colors } from '@offerzen/pinata'

const styles = {
  container: css({
    position: 'relative',
    width: '100%',
    height: 8,
    background: colors.blackPearl,
    top: 0,
    left: 0,
  }),

  track: css({
    position: 'absolute',
    left: 0,
    top: 0,
    background: colors.cornflowerBlue,
    height: '100%',
    transition: '0.3s width',
  }),

  progress: percent =>
    css({
      width: `${percent}%` || 0,
    }),
}

export default styles
